'use strict';
 /**
 * @author Maxim Seredkin
 */
export default ['$log', '$q',
    function ($log, $q) {
        return {
            response: function (response) {
                // if (response.status != 200)
                // $log.debug(response);
                return response;
            },
            responseError: function (rejection) {
                $log.debug(rejection);
                // if (canRecover && canRecover(rejection)) {
                //     return responseOrNewPromise;
                // }
                return $q.reject(rejection);
            }
        };
    }];
